import { useQuery } from '@tanstack/react-query'

import { dataOrThrow } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'

export const paymentMethodsQueryKey = ['portal-payment-methods'] as const

/**
 * Lists the signed-in member's saved cards via
 * `GET /api/portal/billing/payment-methods`. Portal auth already scopes
 * to the current member, so no id is needed on the caller side.
 */
export function useListPaymentMethods() {
  const api = usePortalApi()
  return useQuery({
    queryKey: paymentMethodsQueryKey,
    queryFn: async () => dataOrThrow(await api.get('/billing/payment-methods')),
  })
}
